import React from 'react';
import Header from './components/Header';
// import Form from './components/Form';
import StudentForm from './components/StudentForm';
import Footer from './components/Footer';
import './App.css';

const App = () => (
    <div className="container">
        <Header />
        <StudentForm />
        <Footer />
    </div>
);

export default App;
